
import { defineComponent, SetupContext } from "vue";

export default defineComponent({
  name: "MyListFolderOperation",
  props: {
    /** ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  setup(_, context: SetupContext) {
    /** テキスト */
    const folderDeleteText = "フォルダを削除する";
    const folderRenameText = "フォルダ名を変更する";
    const cancelText = "キャンセル";

    /** フォルダ削除選択 */
    const deleteAction = () => {
      context.emit('select-click', 0);
    };
    /** フォルダ名変更ボタン */
    const renameAction = () => {
      context.emit('select-click', 1);
    };
    /** キャンセル・ボタン */
    const cancelAction = () => {
      context.emit('select-click', 2);
    };


    return {
      folderDeleteText,
      folderRenameText,
      cancelText,
      deleteAction,
      renameAction,
      cancelAction
    };
  }
});
